import type { SalesPartnerStockData } from "~/features/salesPartnerStock/types";
import { occFetch, occUrl } from "~/app/api/occ/occFetch";

export type AffiliateProductStockDTO = Omit<SalesPartnerStockData, "order">;

export interface AffiliateProductStockListResponseDTO {
  items?: AffiliateProductStockDTO[];
}

export async function fetchSalesPartnerStock(productCode: string): Promise<SalesPartnerStockData[]> {
  const response = await occFetch(occUrl(`/p/${productCode}/salespartner`));

  if (!response.ok) {
    console.warn(`API call to fetch sales partner stock failed: ${response.status}`);
    return [];
  }

  const data = ((await response.json()) as AffiliateProductStockListResponseDTO).items;
  if (!Array.isArray(data)) {
    console.warn(`API call to fetch sales partner stock returned invalid data: ${data}`);
    return [];
  }
  return data.map((item) => ({ ...item, order: Math.random() }));
}
